import React from "react";
import { Link } from "react-router-dom";
import { withAlert } from "react-alert";

import DataSender from "../lib/DataSender";

import "./access.css";

class PhoneRead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phone_number: "",
    };
    this.alert = this.props.alert;
    this.ds = new DataSender();
    this.cancel = this.props.location.state
      ? this.props.location.state.cancel
      : "/Main";

    this.input = React.createRef();
  }

  phoneFomatter = (e) => {
    if (e.key === "Enter") {
      this.requestAccess.apply(this);
      return;
    }
    let x = e.target.value
      .replace(/[^0-9]/g, "")
      .replace(
        /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
        "$1-$2-$3"
      )
      .replace("--", "-");
    this.setState({ phone_number: x });
    this.input.current.value = x;
  };

  requestAccess() {
    this.ds
      .accessPhone(this.state.phone_number)
      .then((response) => response.json())
      .then((response) => {
        let to = this.props.location.state.to;
        this.props.history.push({
          pathname: to,
          state: response,
        });
      })
      .catch((err) => {
        this.alert.show("등록된 전화번호가 존재하지 않습니다.");
      });
  }

  render() {
    return (
      <div className="PhoneRead">
        <h1>전화번호를 입력해주세요</h1>
        <div className="wrapper">
          <form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className="group">
              <input type="hidden" name="test" />
              <input
                type="text"
                maxLength="13"
                required="required"
                onKeyUp={this.phoneFomatter}
                // onChange={this.handleChange}
                // value={this.state.phone_number}
                name="phone_number"
                ref={this.input}
              />
              <span className="highlight"></span>
              <span className="bar"></span>
              <label>전화번호 ( 010 - XXXX - XXXX )</label>
            </div>
          </form>
        </div>
        <div className="qrcreate-buttons">
          <div className="qrcreate-button1">
            <button className="button" onClick={this.requestAccess.bind(this)}>
              <p>입장하기</p>
            </button>
          </div>
          <Link to={this.cancel} className="qrcreate-button2">
            <button className="button">
              <p>취소</p>
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default withAlert()(PhoneRead);
